let boundNavigate = null;

export const bindNavigate = navigate => {
    boundNavigate = navigate;
};

export const navigateTo = to => {
    if (boundNavigate) {
        boundNavigate(to);
    } else {
        window.location.assign(to);
    }
};

export const currentHistoryEntry = () => window.history.state?.key ?? 'default';

export const childRoutePath = (path, parent) => path.slice(parent.length + 1);

export const normalizedPathname = pathname => {
    try {
        return decodeURI(pathname).toLowerCase();
    } catch {
        return pathname.toLowerCase();
    }
};
